export const objectToMap = (obj: { [key: string]: any }) => {
  const map = new Map<string, any>(Object.entries(obj));
  return map;
};
